// extracted by mini-css-extract-plugin
export var arcText = "D_cq";